// extracted by mini-css-extract-plugin
module.exports = {"mobile-ad":"mobile-ad--8e5a1","mobileAd":"mobile-ad--8e5a1","ad-container-desktop":"ad-container-desktop--aab5f","adContainerDesktop":"ad-container-desktop--aab5f"};